<vs-dialog
  #editEmailTemplateDialog
  [config]="dialogConfig ?? { dialogContainerClass: 'max-w-[525px]' }"
  (closed)="template = null"
>
  <vs-dialog-header
    *ngIf="template"
    [config]="{
      mode: 'simple',
      hideCloseButton: false,
      icon: 'edit-01',
      iconTheme: 'primary',
      showDivider: true,
      title: template.type,
      subtitle: template.subject ?? ''
    }"
  ></vs-dialog-header>

  <form [formGroup]="form" class="mt-3">
    <div class="grid grid-cols-[1fr_auto] gap-6">
      <div>
        <p class="text-sm text-gray-700 font-medium">Enabled</p>
        <p class="text-sm text-gray-600">Control whether this email is automatically sent when the event fires</p>
      </div>

      <input vsInput type="checkbox" appearance="toggle" class="mt-1 mr-1" formControlName="enabled" />
    </div>

    <vs-form-field theme="primary" [config]="{ label: 'Event' }" class="mt-4">
      <input vsInput type="text" [value]="template?.type ?? ''" disabled />
    </vs-form-field>

    <vs-form-field theme="primary" [config]="{ label: 'Delivery Method' }" class="mt-4">
      <input vsInput type="text" value="Event Based" disabled />
    </vs-form-field>

    <vs-form-field theme="primary" [config]="{ label: 'Template Label' }" class="mt-4">
      <input vsInput type="text" formControlName="templateLabel" />
    </vs-form-field>

    <vs-form-field theme="primary" [config]="{ label: 'Subject' }" class="mt-4">
      <input vsInput type="text" formControlName="subject" />
    </vs-form-field>

    <vs-form-field theme="primary" [config]="{ label: 'Byline' }" class="mt-4">
      <input vsInput type="text" formControlName="byline" />
    </vs-form-field>

    <label class="text-gray-700 font-medium" style="font-size: 0.875rem; line-height: 2.25rem">Content</label>
    <vs-rich-text-editor *ngIf="template" formControlName="content"></vs-rich-text-editor>
  </form>

  <ng-container *ngIf="tokens.length">
    <div class="mt-5 border border-gray-200 rounded-lg p-4">
      <p class="text-sm font-semibold text-gray-700 mb-1">Available Tokens</p>
      <p class="text-xs text-gray-500 mb-3">
        Click a token to copy it, then paste it into the subject or content fields above.
      </p>

      <div class="flex flex-col gap-2">
        <div *ngFor="let token of tokens" class="flex items-start justify-between gap-3">
          <div class="flex-1 min-w-0">
            <p class="text-xs text-gray-500">{{ token.description }}</p>
            <p class="text-xs text-gray-400 italic">e.g. {{ token.example }}</p>
          </div>

          <button
            vs-button
            size="sm"
            appearance="outline"
            class="font-mono text-xs shrink-0"
            [cdkCopyToClipboard]="token.token"
            (cdkCopyToClipboardCopied)="copyToken(token.token)"
          >
            <vs-icon *ngIf="copiedToken === token.token" name="check" size="xs"></vs-icon>
            <vs-icon *ngIf="copiedToken !== token.token" name="copy-01" size="xs"></vs-icon>
            {{ token.token }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="flex footer mt-5 gap-2 justify-end">
    <button vs-button size="md" appearance="outline" [disabled]="saving" (click)="cancel()">Cancel</button>
    <button vs-button size="md" theme="primary" [disabled]="saving || !form.dirty" (click)="submit()">Update</button>
  </div>
</vs-dialog>
